// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__jra2I","hidden":"Header_hidden__nw8He"};